import { mods } from '@approvalmax/theme';
import { StyledMods } from '@styled-kit/mods';
import { WarningLevel } from 'modules/request';
import styled, { css } from 'styled-components';

import { getCellIndicatorColor } from './CellIndicator.helpers';

/**
 * @deprecated Use redesigned component {@link CellWarningIndicator}
 */
export const CellIndicator = styled.div<StyledMods<{ warningLevel: WarningLevel }>>`
    position: absolute;
    right: 0;
    top: 5px;
    bottom: 5px;
    width: 5px;
    ${mods('warningLevel')(
        (value) => css`
            background: ${getCellIndicatorColor(value)};
        `
    )}
`;
